import React from 'react';

import {
  formatDateTime,
  formatTimeSpan,
  getClientTimeZone,
  useDate,
  Dateable,
  TimeSpanFormatter,
} from '@zapier/date';

interface RelativeTimeProp {
  date: Dateable;
  formatter?: TimeSpanFormatter;
  hasSuffix?: boolean;
}

const RelativeTime = (props: RelativeTimeProp) => {
  const { date, formatter = formatTimeSpan, hasSuffix } = props;
  // Get timezone from AppProvider (if exists)
  const { timezone } = useDate();

  // fallback to client timezone then to UTC if that fails
  const clientTimezone = timezone || getClientTimeZone() || 'UTC';

  const formattedISODate = formatDateTime(date, 'iso', clientTimezone);

  return (
    <time dateTime={formattedISODate} title={formattedISODate}>
      {formatter(Date.now(), date, hasSuffix !== false)}
    </time>
  );
};

export default RelativeTime;
